import template from './template.html'

angular.module('contabilidad.polizas')
  .component('contabilidadPolizasFacturascanceladasLista', {
    bindings: {
      opciones: '<',
      operadoras: '<',
    },
    template,
    controller: Controller,
  })
Controller.$inject = ['ContabilidadPolizasFacturascanceladas', '$dialog']

function Controller (ContabilidadPolizasFacturascanceladas, $dialog) {
  var $ctrl = this
  $ctrl.$onInit = $onInit
  $ctrl.exportar = exportar

  function $onInit () {
    $ctrl.data = []
    $ctrl.$promise = ContabilidadPolizasFacturascanceladas.get($ctrl.opciones.fecha_inicio, $ctrl.opciones.fecha_fin, $ctrl.opciones.idEmpresa).then(function (response) {
      $ctrl.data = response.data
      $ctrl.data.forEach(function (item) {
        item.abono = item.transacciones.reduce(function (valor, item) {
          return item.naturaleza === 'A' ? valor + (+item.importe) : valor
        }, 0)
        item.carga = item.transacciones.reduce(function (valor, item) {
          return item.naturaleza === 'C' ? valor + (+item.importe) : valor
        }, 0)
        item.carga.toFixed(2)
        item.abono.toFixed(2)
      })
    })
  }

  function exportar () {
    $dialog.show('contabilidad.polizas.exportar', {
      data: $ctrl.data,
      fecha_inicio: $ctrl.opciones.fecha_inicio,
      // Se agregó ésta propiedad para indicar qué es lo que se va a exportar
      config: {
        fecha_inicio: $ctrl.opciones.fecha_inicio,
        fecha_fin: $ctrl.opciones.fecha_fin,
        clientes: $ctrl.operadoras.filter(function (item) {
          return $ctrl.opciones.idEmpresa === item.kardex_id_empleado
        }),
        archivo: 'Facturacion' + $ctrl.opciones.fecha_inicio.toYMD(),
        tipo_poliza: 'facturacioncanceladas',
      },
    })
  }
}



// WEBPACK FOOTER //
// ./src/contabilidad/polizas/components/facturascanceladas/lista/component.js